import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import React from "react";

import Icon from "./nounproject-ui-icon";
import EduPricing from "../components/nounproject-edu-pricing";

class NounProjectPluginLogin extends React.Component {
    attemptSubmitForm(e) {
        e.preventDefault();

        let password = this.passwordInput.value,
            email = this.emailInput.value;

        this.setState({
            processing: true,
            fieldErrors: {}
        });

        let formData = $(".login-form").serialize(); // allauth is done and somehow can't read FormData form = document.querySelector(".login-form"); new FormData(form);

        this.props.login(formData);
    }

    clearErrors() {
        this.setState({
            processing: false,
            error: false,
            fieldErrors: {}
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.error) {
            this.setState({
                processing: false,
                error: true,
                fieldErrors: nextProps.error
            });
        }
    }

    constructor(props) {
        super(props);

        this.state = {
            processing: false,
            error: null,
            fieldErrors: {},
            priceInDollars: "19",
            priceInCents: "99"
        };
    }

    render() {
        let emailLabel,
            emailInputClasses = ["input"],
            passwordLabel,
            passwordInputClasses = ["input"],
            submitButtonClasses = [
                "button",
                "button-process",
                "blue",
                "full-width",
                "ui_key"
            ],
            inputDisabled;

        if (this.state.processing) {
            submitButtonClasses.push("processing");
            inputDisabled = "disabled";
        }

        if (this.state.fieldErrors.__all__) {
            emailLabel = (
                <label className="show error on" style={{ color: "#F44E4E" }}>
                    {this.state.fieldErrors.__all__[0]}
                </label>
            );
            emailInputClasses.push("error on");
        } else {
            if (this.state.fieldErrors.login) {
                emailLabel = (
                    <label
                        htmlFor="user_id"
                        className="show error on"
                        style={{ color: "#F44E4E" }}
                    >
                        {this.state.fieldErrors.login[0]}
                    </label>
                );
                emailInputClasses.push("error on");
            } else {
                emailLabel = (
                    <label
                        htmlFor="user_id"
                        data-label-text="Email Address"
                        className="on show"
                    >
                        Email Address
                    </label>
                );
            }
        }

        if (this.state.fieldErrors.password) {
            passwordLabel = (
                <label
                    htmlFor="id_password"
                    className="show error on"
                    style={{ color: "#F44E4E" }}
                >
                    {this.state.fieldErrors.password[0]}
                </label>
            );
            passwordInputClasses.push("error on");
        } else {
            passwordLabel = (
                <label
                    htmlFor="id_password"
                    data-label-text="Password"
                    className="on show"
                >
                    Password
                </label>
            );
        }

        return (
            <div className="container">
                <span
                    className="row"
                    style={{
                        color: "white",
                        minHeight: "100%"
                    }}
                >
                    <style>{`
                        #for-edu{
                            background: #000000;
                        }
                        #for-edu::before{
                            content: ' ';
                            position: fixed;
                            top: 0;
                            left: 0;
                            background: #1a1a1a;
                            height: 100%;
                            width: 50%;
                        }
                        .billing-list-of-apps .app-list-app{
                            font-size: 12px;
                            justify-content: flex-start;
                            align-items: center;
                            padding: 4px 8px;
                        }
                        .billing-list-of-apps .app-list-app img{
                            margin-right: 8px;
                        }
                    `}</style>

                    <div className="loginView col-lg-5 col-md-5 col-sm-5 col-xs-12">
                        <style>{`
                        .loginView .text-link,
                        .loginView .text-link:hover {
                            color: white
                        }
                    `}</style>

                        <form
                            action={`/accounts/login/?next=/plugin/${
                                this.props.host
                            }#/search`}
                            method="POST"
                            className="margin-t-xxl new-form dark-form login-form plugin-form"
                            onSubmit={this.attemptSubmitForm.bind(this)}
                        >
                            <h1 className="weight-medium margin-b-l">
                                Log in to Noun Project
                            </h1>
                            <ol>
                                <li className="padding-b-s">
                                    <input
                                        id="user_id"
                                        className={emailInputClasses.join(" ")}
                                        maxLength="254"
                                        name="login"
                                        type="text"
                                        required=""
                                        placeholder="Email Address"
                                        autoFocus="autofocus"
                                        ref={input => {
                                            this.emailInput = input;
                                        }}
                                        disabled={inputDisabled}
                                    />
                                    {emailLabel}
                                    <label
                                        htmlFor="user_id"
                                        className="ui_icon ui_email"
                                    />
                                </li>
                                <li className="padding-b-s">
                                    <input
                                        id="id_password"
                                        maxLength="4096"
                                        name="password"
                                        type="password"
                                        placeholder="Password"
                                        className={passwordInputClasses.join(
                                            " "
                                        )}
                                        required=""
                                        ref={input => {
                                            this.passwordInput = input;
                                        }}
                                        disabled={inputDisabled}
                                    />
                                    {passwordLabel}
                                    <label
                                        htmlFor="id_password"
                                        className="ui_icon ui_lock"
                                    />
                                </li>
                                <li>
                                    <a
                                        href="/login/forgot/"
                                        target="_blank"
                                        className="text-link"
                                    >
                                        I forgot my password
                                    </a>
                                </li>
                            </ol>
                            <button
                                className={submitButtonClasses.join(" ")}
                                type="submit"
                            >
                                <span>Log in</span>
                            </button>
                        </form>
                        <div
                            className="margin-t-s"
                            style={{ textAlign: "center" }}
                        />
                        <ol className="margin-t-xxl">
                            <li style={{ textAlign: "center" }}>
                                <a
                                    className="already-have-account text-link"
                                    href="/plugin/#/signup"
                                    onClick={this.showSignup.bind(this)}
                                >
                                    <span>I need to create an account</span>
                                </a>
                            </li>
                        </ol>
                    </div>
                    <div className="col-lg-5 col-md-5 col-sm-5 col-sm-offset-2 col-sm-12">
                        <EduPricing />
                    </div>
                </span>
            </div>
        );
    }
    showSignup(e) {
        e.preventDefault();
        browserHistory.push("/for-edu/signup/");
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(mapStateToProps, {})(NounProjectPluginLogin);
